import { CollapseProps, Descriptions, Grid, Typography } from 'antd';
import Parser from 'html-react-parser';
import { Fragment, useContext } from 'react';
import CollapseCustom from 'src/components/v2/Collapse';
import { TicketDetailContext } from 'src/contexts/ticketDetail.context';
import { ITicketSolution } from 'src/types/helpdesk/ticketSolution.type';
import { formatDate, formatToVND } from 'src/utils/utils';
import './ticketDetailSolution.scss';

const { Text } = Typography;

const solutionItems = (solutions: ITicketSolution[], colspan: number): CollapseProps['items'] => {
  return solutions?.map((item, index) => ({
    key: index,
    label: (
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
        key={index}
      >
        <Descriptions.Item label='Tiêu đề'>
          <Text strong>{item.title}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Người đề xuất'>
          <Text strong italic>
            {item.solutionBy?.name}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label='Dự kiến hoàn thành'>
          <Text>{formatDate(item.estimatedTime)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Chi phí ước tính'>
          <Text>{formatToVND(String(item.estimatedCost || ''))}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ngày tạo'>
          <Text>{formatDate(item.createdDate)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ngày cập nhật'>
          <Text>{formatDate(item.lastModifiedDate)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Nội dung giải pháp' span={colspan}>
          <Text>{Parser(item.solution ? item.solution : '')}</Text>
        </Descriptions.Item>
      </Descriptions>
    ),
    showArrow: false,
    className: 'solution-ticket-item'
  }));
};

const TicketDetailSolution = (): JSX.Element => {
  const { ticket } = useContext(TicketDetailContext);

  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const colspan = breakpoints.xxl ? 2 : 1;

  return (
    <Fragment>
      {ticket?.data.ticketSolutions && ticket?.data.ticketSolutions?.length > 0 && (
        <CollapseCustom
          isFullDefault
          title='Danh sách giải pháp'
          titleLevel={5}
          isSegmented={false}
          collapsible='disabled'
          items={solutionItems(ticket?.data.ticketSolutions || [], colspan)}
          expandIconPosition='end'
          className='solution-ticket-collapse'
        />
      )}
    </Fragment>
  );
};
export default TicketDetailSolution;
